import React, { useEffect, useState } from 'react';
import { Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import Stack from '@mui/material/Stack';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PreviousStepButton from './PreviousStepButton';
import { CGProduct } from 'types/shopify';
import { availableSteps } from '../CardConfigurer/configurerFlags';

interface CardCustomisationTabsProps {
  onChange?: (value: React.SetStateAction<number>) => void;
  currentTab: number;
  product?: CGProduct;
  disabledSteps?: string[];
}

const a11yProps: (index: number) => {} = (index: number) => ({
  id: `full-width-tab-${index}`,
  'aria-controls': `full-width-tabpanel-${index}`,
});

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    disabled: {
      display: 'none',
    },
    visited: {
      '& > span': {
        color: theme.palette.secondary.light,
      },
    },
  }),
  { name: 'CardCustomisationTabs' },
);

const StyledTabs = withStyles((theme: Theme) => {
  return {
    root: {},
    indicator: {
      display: 'none',
    },
  };
})(Tabs);

const StyledTab = withStyles((theme) => ({
  root: {
    ...theme.typography.subtitle2,
    color: '#8f8f8f',
    minWidth: 'auto',
    '&:focus': {
      opacity: 1,
    },
    textTransform: 'none',
    '&:first-child': {
      paddingLeft: 0,
    },
  },
}))((props: any) => <Tab disableRipple {...props} />);

const CardCustomisationTabs: React.FC<CardCustomisationTabsProps> = ({ onChange, currentTab = 0, product, disabledSteps = [] }) => {
  const classes = useStyles();
  const [maxVisitedstep, setMaxVisitedStep] = useState(0);

  useEffect(() => {
    if (currentTab > maxVisitedstep) setMaxVisitedStep(currentTab);
  }, [currentTab, maxVisitedstep]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue < currentTab) {
      onChange && onChange(newValue);
    }
  };
  const steps = product ? availableSteps(product.productType) : [];

  return (
    <Stack direction={'row'}>
      <PreviousStepButton disabledSteps={disabledSteps} steps={steps} currentStep={currentTab} setStep={onChange} sx={{ mr: 2 }} />
      <StyledTabs value={currentTab} onChange={handleChange} indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons={false} aria-label="card customisation tabs">
        {steps &&
          steps.map((item, index) => {
            const extra = disabledSteps.includes(item)
              ? {
                  disabled: true,
                  className: classes.disabled,
                }
              : {
                  className: index <= maxVisitedstep && index !== currentTab ? classes.visited : null,
                };

            return <StyledTab key={'styledTab-' + index} label={item} {...a11yProps(index)} {...extra} />;
          })}
      </StyledTabs>
    </Stack>
  );
};

export default CardCustomisationTabs;
